"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.authMachine = exports.AuthEventType = exports.AuthStates = void 0;

var _xstate = require("xstate");

var _oneClub = require("../../services/oneClub");

var _common = require("../../utils/common");

var _login = require("../../api/login");

var _authority = require("../../api/authority");

var _constants = require("../../constants");

var _on2, _on3, _states;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AuthStates = {
  Init: "Init",
  Idle: "Idle",
  Loading: "Loading",
  LoginDone: "LoginDone",
  ReadySettingEducation: "ReadySettingEducation",
  SettingEducation: "SettingEducation",
  getAuthority: "getAuthority",
  UpdateUserProfile: "UpdateUserProfile"
};
exports.AuthStates = AuthStates;
var AuthEventType = {
  Logging: "Logging",
  LoggingOut: "LoggingOut",
  LoggingEnd: "LoggingEnd",
  SetEducation: "SetEducation",
  UpdatingUserProfile: "UpdatingUserProfile"
};
exports.AuthEventType = AuthEventType;
var init = {
  identity: "",
  name: "",
  eduMap: [],
  subject: "",
  education: [],
  account: ""
};
var authMachine = (0, _xstate.createMachine)({
  id: "loginMachine",
  initial: AuthStates.Init,
  context: {
    result: _objectSpread({}, init),
    apiBaseUrl: "",
    productApiUrl: "",
    authority: {},
    error: null,
    loading: false
  },
  states: (_states = {}, _defineProperty(_states, AuthStates.Init, {
    always: [{
      target: AuthStates.Loading,
      cond: function cond() {
        return (0, _oneClub.checkNaniLinkLogin)() !== "";
      }
    }, {
      target: AuthStates.Idle
    }]
  }), _defineProperty(_states, AuthStates.Idle, {
    entry: (0, _xstate.assign)({
      result: function result() {
        (0, _common.deleteAllCookies)();
        return _objectSpread({}, init);
      },
      loading: function loading() {
        return false;
      }
    }),
    on: _defineProperty({}, AuthEventType.Logging, AuthStates.Loading)
  }), _defineProperty(_states, AuthStates.Loading, {
    invoke: {
      src: function () {
        var _src = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context, event) {
          var resourcePlatformToken, profile, naniToken, result, data, _profile, token;

          return regeneratorRuntime.wrap(function _callee$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  resourcePlatformToken = (0, _common.checkLogin)(_constants.COOKIE_LOGIN_TOKEN_NAME);

                  if (!resourcePlatformToken) {
                    _context2.next = 9;
                    break;
                  }

                  _context2.next = 4;
                  return (0, _login.loginGetUserProfile)({
                    url: context.apiBaseUrl
                  });

                case 4:
                  profile = _context2.sent;

                  if (profile !== null && profile !== void 0 && profile.isSuccess) {
                    _context2.next = 7;
                    break;
                  }

                  return _context2.abrupt("return", Promise.reject(profile));

                case 7:
                  _context2.next = 29;
                  break;

                case 9:
                  naniToken = (0, _oneClub.checkNaniLinkLogin)() || "";
                  _context2.next = 12;
                  return (0, _login.loginByOneClub)({
                    url: context.apiBaseUrl,
                    jwt: naniToken ? JSON.parse(naniToken).jwt : JSON.parse(event.jwt).jwt
                  });

                case 12:
                  result = _context2.sent;
                  data = result.data;

                  if (!(typeof data === "string")) {
                    _context2.next = 26;
                    break;
                  }

                  //非首次登入
                  (0, _common.setCookie)(_constants.COOKIE_LOGIN_TOKEN_NAME, data, 1);
                  _context2.next = 18;
                  return (0, _login.loginGetUserProfile)({
                    url: context.apiBaseUrl
                  });

                case 18:
                  _profile = _context2.sent;

                  if (!_profile.isSuccess) {
                    _context2.next = 23;
                    break;
                  }

                  return _context2.abrupt("return", _objectSpread({
                    token: data
                  }, _profile.data));

                case 23:
                  return _context2.abrupt("return", Promise.reject(_profile));

                case 24:
                  _context2.next = 29;
                  break;

                case 26:
                  token = data.token;
                  (0, _common.setCookie)(_constants.COOKIE_LOGIN_TOKEN_NAME, token, 1);
                  return _context2.abrupt("return", data);

                case 29:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee);
        }));

        function src(_x, _x2) {
          return _src.apply(this, arguments);
        }

        return src;
      }(),
      onDone: [{
        target: AuthStates.ReadySettingEducation,
        cond: function cond(_, event) {
          var _event$data;

          return event !== null && event !== void 0 && (_event$data = event.data) !== null && _event$data !== void 0 && _event$data.isNewMember ? true : false;
        },
        actions: (0, _xstate.assign)({
          result: function result(_context, event) {
            return event.data;
          },
          error: function error() {
            return null;
          },
          loading: function loading() {
            return true;
          }
        })
      }, {
        target: AuthStates.getAuthority,
        actions: (0, _xstate.assign)({
          result: function result(_context, event) {
            return event.data;
          },
          error: function error() {
            return null;
          },
          loading: function loading() {
            return true;
          }
        })
      }],
      onError: {
        target: AuthStates.Idle,
        actions: (0, _xstate.assign)({
          result: function result(_context) {
            (0, _oneClub.logoutNaniOneClass)();
            return _objectSpread({}, init);
          },
          error: function error(_, event) {
            var _event$data2, _event$data2$data;

            var newMessage = (event === null || event === void 0 ? void 0 : (_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : (_event$data2$data = _event$data2.data) === null || _event$data2$data === void 0 ? void 0 : _event$data2$data.message) || "您的帳號已重複登入！";
            return newMessage;
          }
        })
      }
    }
  }), _defineProperty(_states, AuthStates.ReadySettingEducation, {
    on: (_on2 = {}, _defineProperty(_on2, AuthEventType.SetEducation, {
      target: AuthStates.SettingEducation
    }), _defineProperty(_on2, AuthEventType.LoggingOut, {
      target: AuthStates.Idle
    }), _on2)
  }), _defineProperty(_states, AuthStates.SettingEducation, {
    invoke: {
      id: "SettingEducation",
      src: function () {
        var _src2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(context, event) {
          var result, isSuccess, data;
          return regeneratorRuntime.wrap(function _callee2$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return (0, _login.setUserProfile)({
                    url: context.apiBaseUrl,
                    payload: {
                      education: [event.chooseEdu]
                    }
                  });

                case 2:
                  result = _context3.sent;
                  isSuccess = result.isSuccess, data = result.data;

                  if (isSuccess) {
                    _context3.next = 6;
                    break;
                  }

                  throw new {
                    error: "error"
                  }();

                case 6:
                  return _context3.abrupt("return", data);

                case 7:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee2);
        }));

        function src(_x3, _x4) {
          return _src2.apply(this, arguments);
        }

        return src;
      }(),
      onDone: {
        target: AuthStates.getAuthority,
        actions: (0, _xstate.assign)({
          result: function result(_context, event) {
            return _objectSpread(_objectSpread({}, event.data), {}, {
              isNewMember: _context.result.isNewMember
            });
          },
          error: function error() {
            return null;
          },
          loading: function loading() {
            return true;
          }
        })
      },
      onError: {
        target: AuthStates.Idle,
        actions: (0, _xstate.assign)({
          result: function result(_context, event) {
            (0, _oneClub.logoutNaniOneClass)();
            return _objectSpread({}, init);
          },
          error: function error(event) {
            return event.error;
          }
        })
      }
    }
  }), _defineProperty(_states, AuthStates.getAuthority, {
    invoke: {
      src: function () {
        var _src3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(context) {
          var _yield$getUserAuthori, isSuccess, data;

          return regeneratorRuntime.wrap(function _callee3$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return (0, _authority.getUserAuthority)(context.productApiUrl);

                case 2:
                  _yield$getUserAuthori = _context4.sent;
                  isSuccess = _yield$getUserAuthori.isSuccess;
                  data = _yield$getUserAuthori.data;

                  if (isSuccess) {
                    _context4.next = 7;
                    break;
                  }

                  return _context4.abrupt("return", Promise.reject(data));

                case 7:
                  return _context4.abrupt("return", {
                    authority: (data === null || data === void 0 ? void 0 : data.authority) || [],
                    data: data
                  });

                case 8:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee3);
        }));

        function src(_x5) {
          return _src3.apply(this, arguments);
        }

        return src;
      }(),
      onDone: {
        target: AuthStates.LoginDone,
        actions: (0, _xstate.assign)({
          authority: function authority(_, event) {
            return event.data.authority;
          },
          result: function result(_context, event) {
            return _objectSpread(_objectSpread({}, _context.result), event.data.data);
          }
        })
      },
      onError: {
        target: AuthStates.Idle,
        actions: (0, _xstate.assign)({
          result: function result(_context, event) {
            (0, _oneClub.logoutNaniOneClass)();
            return _objectSpread({}, init);
          },
          error: function error(_, event) {
            return event.data;
          }
        })
      }
    }
  }), _defineProperty(_states, AuthStates.UpdateUserProfile, {
    invoke: {
      src: function () {
        var _src4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(context, event) {
          var _yield$getUserAuthori2, isSuccess, data;

          return regeneratorRuntime.wrap(function _callee4$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return (0, _authority.getUserAuthority)(context.productApiUrl);

                case 2:
                  _yield$getUserAuthori2 = _context5.sent;
                  isSuccess = _yield$getUserAuthori2.isSuccess;
                  data = _yield$getUserAuthori2.data;

                  if (isSuccess) {
                    _context5.next = 7;
                    break;
                  }

                  return _context5.abrupt("return", Promise.reject(data));

                case 7:
                  return _context5.abrupt("return", data);

                case 8:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee4);
        }));

        function src(_x6, _x7) {
          return _src4.apply(this, arguments);
        }

        return src;
      }(),
      onDone: {
        target: AuthStates.LoginDone,
        actions: (0, _xstate.assign)({
          result: function result(_context, event) {
            return _objectSpread(_objectSpread({}, _context.result), event.data);
          }
        })
      },
      onError: {
        target: AuthStates.Idle,
        actions: (0, _xstate.assign)({
          result: function result(_context, event) {
            (0, _oneClub.logoutNaniOneClass)();
            return _objectSpread({}, init);
          },
          error: function error(event) {
            return event.error;
          }
        })
      }
    }
  }), _defineProperty(_states, AuthStates.LoginDone, {
    on: (_on3 = {}, _defineProperty(_on3, AuthEventType.LoggingOut, {
      target: AuthStates.Idle
    }), _defineProperty(_on3, AuthEventType.UpdatingUserProfile, {
      target: AuthStates.UpdateUserProfile
    }), _on3)
  }), _states)
});
exports.authMachine = authMachine;
var _default = authMachine;
exports.default = _default;